import {
  CreateTribeTemplateRequest,
  UpdateTribeTemplateRequest,
  ViewTribeTemplateRequest
} from './tribe-template.types';

import {
  API_HOST,
  HttpGetOptions,
  HttpPostOptions,
  HttpPutOptions,
  getHttpGetOptions,
  getHttpPostOptions,
  getHttpPutOptions
} from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/tribe-template`;
const getSpecificEndpoint = (externalReference: string) => `${getEndpoint()}/${externalReference}`;

export const getCreateTribeTemplateRequest = (
  data: CreateTribeTemplateRequest
): [string, HttpPostOptions<CreateTribeTemplateRequest>] => [getEndpoint(), getHttpPostOptions(data)];

export const getViewTribeTemplateRequest = (data: ViewTribeTemplateRequest): [string, HttpGetOptions] => [
  getSpecificEndpoint(data.programmeExternalReference),
  getHttpGetOptions()
];

export const getUpdateTribeTemplateRequest = (
  data: UpdateTribeTemplateRequest
): [string, HttpPutOptions<UpdateTribeTemplateRequest>] => [getEndpoint(), getHttpPutOptions(data)];
